const MAX_COLOR = 200 // Max value for a color component
const MIN_COLOR = 120 // Min value for a color component
const FILL_CHANCE = 0.5 // Chance of a square being filled [0, 1]
const SQUARE = 80 // Size of a grid square in pixels
const GRID = 5 // Number of squares width and height
const PADDING = SQUARE / 2 // Padding on the edge of the canvas in px
const SIZE = SQUARE * GRID + PADDING * 2 // Size of the canvas
const FILL_COLOR = '#EEEEEE' // canvas background color

/**
 * Create a temporary canvas
 */
function setupCanvas () {
  const canvas = document.createElement('canvas')
  canvas.width = SIZE
  canvas.height = SIZE

  // Fill canvas background
  const context = canvas.getContext('2d')
  context.beginPath()
  context.rect(0, 0, SIZE, SIZE)
  context.fillStyle = FILL_COLOR
  context.fill()
  return canvas
}
/**
 * Fill in a square of the canvas
 */
function fillBlock (x, y, color, context) {
  context.beginPath()
  context.rect(PADDING + x * SQUARE, PADDING + y * SQUARE, SQUARE, SQUARE)
  context.fillStyle = 'rgb(' + color.join(',') + ')'
  context.fill()
}
/**
 * Generate a random color with low saturation.
 */
function generateColor () {
  const rgb = [ ]
  for (let i = 0; i < 3; i++) {
    const val = Math.floor(Math.random() * 256)
    const minEnforced = Math.max(MIN_COLOR, val)
    const maxEnforced = Math.min(MAX_COLOR, minEnforced)
    rgb.push(maxEnforced)
  }
  return rgb
}
/**
 * Generate a random identicon
 */
export function generateIdenticon () {
  const canvas = setupCanvas()
  const context = canvas.getContext('2d')
  const color = generateColor() // Generate custom tile color

  // Iterate through squares on left side
  for (let x = 0; x < Math.ceil(GRID / 2); x++) {
    for (let y = 0; y < GRID; y++) {
      // Randomly fill squares
      if (Math.random() < FILL_CHANCE) {
        fillBlock(x, y, color, context)

        // Fill right side symmetrically
        if (x < Math.floor(GRID / 2)) {
          fillBlock((GRID - 1) - x, y, color, context)
        }
      }
    }
  }
  return canvas.toDataURL()
}

export default {
  name: 'AvatarGenerator',
  data () {
    return {
      src: undefined
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.src = generateIdenticon()
    })
  },
  render (h) {
    return this.$scopedSlots.default({
      src: this.src
    })
  }
}
